import _ from 'lodash'

export const unescape = str => _.unescape(str)
  .replace(/&amp;/g, '&')
  .replace(/&lt;/g, '<')
  .replace(/&gt;/g, '>')
  .replace(/(&quot;)/g, '')
  .replace(/&hearts;/g, '♥')
  .replace(/\\n/g, '<br>')
  .replace(/&lt!;/g, '<!')
  .replace(/(&quot;|\\n)/g, '"')
  .replace(/(&middot;|\\n)/g, '·')
  .replace(/(&bull;|\\n)/g, '•')
  .replace(/&nbsp;/g, ' ')
  .replace(/(&#035;|\\n)/g, '#')
  .replace(/(&#039;|\\n)/g, "'")
  .replace(/(&quot;)/g, '')
  .replace(/&lsquo;/g, '‘')
  .replace(/&rsquo;/g, '’')
  .replace(/&ldquo;/g, '“')
  .replace(/&rdquo;/g, '”')
  .replace(/&zwj;♀️/, '')
  .replace(/&times;/g, '×')
  .replace(/&hellip;/g, '…')

export const defaultString = (obj, defaultStr = '') => {
  if (obj === null || typeof obj === 'undefined') {
    return defaultStr
  }

  return (typeof obj === 'string') ? obj : obj.toString()
}
/**
 * 주어진 문자열에서 숫자가 아닌 문자를 제거한 문자열을 반환
 * org.apache.commons.lang3.StringUtils.getDigits(String str) 메소드와 동일
 * @param {string} str 문자열
 * @return {string} 숫자가 아닌 문자를 제거된 문자열
 */
export const getDigits = (str) => {
  return defaultString(str).replace(/[^0-9]/g, '')
}
export const getDigitsWithMinus = (str) => {
  return defaultString(str).replace(/[^-0-9]/g, '')
}

// 숫자 콤마 찍기
export const numberComma = (obj) => {
  return Number(getDigits(obj)).toLocaleString('ko-KR')
}
export const numberCommaWithMinus = (obj) => {
  return Number(getDigitsWithMinus(obj)).toLocaleString('ko-KR')
}

// empty 검사
export const isNotEmpty = (obj) => {
  return (obj !== null && typeof obj !== 'undefined' && obj !== '')
}

export const reContents = (text) => {
  return text.split('\n')
}

export const convertMaxNumber = (count) => {
  return count > 9999 ? '9,999+' : Number(count).toLocaleString()
}

// alert 메시지 이미지 래핑
const DEFAULT_ALERT_IMAGE = '/images/icon/alert_check.gif'

export const wrapAlertMessage = (message, imageUrl) => {
  const img = imageUrl || DEFAULT_ALERT_IMAGE
  return `
    <div class="check-img">
      <img src="${img}" alt="icon">
    </div>
    <p>${message}</p>
  `
}
